import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import {
  Alert,
  Icon,
  Layout,
  Input,
  Table,
  Button,
  Modal,
  message,
  Select, Tooltip, Switch, Checkbox,
} from "antd";
import {Link} from "react-router-dom";

import SpecimenSampleUploadForm from "./SpecimenSampleUploadForm/SpecimenSampleUploadForm";
import SpecimenSampleEditForm from "./SpecimenSampleEditForm/SpecimenSampleEditForm";
import classes from "./SpecimenSampleEditor.css";
import { withNamespaces } from "react-i18next";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  activateSpecimenSampleRequest,
  deactivateSpecimenSampleRequest,
  getSpecimenSamplesSearchRequest, getSettingsSitesRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getSpecimenSampleCreatePermission,
  getSpecimenSampleUpdatePermission,
  getUserTimezone,
  getUserShortTimezone,
} from "../../reducers/user/selectors";
import {withParams} from "../../utils/url";
const routes = require('../../routes.json');

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

class SpecimenSampleEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      specimenSamples: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      site: null,
      filter: null,
      order: "asc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: {},
      specimenSampleAdd: null,
      specimenSampleEdit: null,
      filterBy: null,
      filterValue: null,
      approvedSelected: null,
      statusFilters: [],
      sitesList: [],
      isFilterApprove: false,
    };
  }

  async componentDidMount() {
    this.onNameSearch();
    this.getSitesList();
  }

  onNameSearch = async (value) => {
    this.setState(
      {
        nameSearch: value,
        filterBy: null,
        filterValue: null,
        eventsSelected: {},
      },
      this.getSpecimenSamples
    );
  };

  getSpecimenSamples = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getSpecimenSamplesSearchRequest({
        nameSearch: this.state.nameSearch,
        page,
        per_page,
        order_direction: this.state.order,
        order_column: get(this.state, "sortedInfo.columnKey"),
        filter_by: this.state.filterBy,
        filter_value: this.state.filterValue,
        filter_approve: this.state.isFilterApprove || undefined,
      });

      if (Array.isArray(data.data)) {
        this.setState({
          checkedItems: [],
        });

        this.setState({
          specimenSamples: data.data,
          total: data.total_pages * per_page,
          currentPage: page,
        });
      } else {
        this.setState({
          specimenSamples: [data],
          total: 1 * per_page,
          currentPage: page,
        });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getSpecimenSamples(pagination.current, pagination.pageSize)
    );
  };

  onSpecimenSampleEditHide = () => {
    this.setState({ specimenSampleEdit: null });
  };

  onSpecimenSampleEditSubmit = () => {
    this.setState({ specimenSampleEdit: null }, this.getSpecimenSamples);
  };

  onSpecimenSampleAddHide = () => {
    this.setState({ specimenSampleAdd: null });
  };

  onSpecimenSampleAddSubmit = () => {
    this.setState({ specimenSampleAdd: null }, this.getSpecimenSamples);
  };

  addSpecimenSample = () => {
    this.setState({ specimenSampleAdd: {} });
  };

  clearFilters = () => {
    this.setState({ nameSearch: null, filterBy: null, filterValue: null }, this.getSpecimenSamples);
  };

  onSwitchActivation = (id, state) => async () => {
    try {
      if (state === "active") {
        await deactivateSpecimenSampleRequest(id);
      } else {
        await activateSpecimenSampleRequest(id);
      }

      message.success("Saved");

      this.getSpecimenSamples();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
      console.log(e);
    }
  };

  getSitesList = async () => {
    try {
      const { data } = await getSettingsSitesRequest();
      this.setState({ sitesList: data });
    } catch (e) { if (e.response.status === 401) { this.props.logout();  return; } console.log(e); }
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      nameSearch,
      specimenSamples,
      currentPage,
      total,
      pageSize,
      specimenSampleAdd,
      specimenSampleEdit,
      sortedInfo,
      sitesList,
      isFilterApprove,
    } = this.state;
    const {
      specimenSampleCreatePermission,
    } = this.props;

    let columns = [
      {
        dataIndex: "id",
        key: "id",
        title: "ID",
      },
      {
        dataIndex: "code",
        key: "code",
        title: this.props.i18n.t("NamespaceSpecimenSample:Code"),
      },
      {
        dataIndex: "kit",
        key: "kit",
        title: this.props.i18n.t("Kit"),
      },
      {
        dataIndex: "subject",
        key: "subject",
        title: this.props.i18n.t("Subject"),
        render: (val, item) => <Link to={withParams(routes.admin.patientProfileSingle, { subjectID: get(val, 'profile.code')})}>{get(val, 'code')}</Link>,
      },
      {
        dataIndex: "event",
        key: "event",
        title: this.props.i18n.t("Event"),
        render: (val, item) => <span>{get(val, 'name')}</span>,
      },
      {
        dataIndex: "sample_type",
        key: "sample_type",
        title: this.props.i18n.t("NamespaceSpecimenSample:Sample Type"),
        render: (val, item) => <span>{val}</span>,
      },
      {
        dataIndex: "site",
        key: "site",
        title: this.props.i18n.t("Site code & name"),
        render: (val, item) => (get(val, 'code') && <span>{get(val, 'code') + ' - ' + get(val, 'name')}</span>)
      },
      {
        dataIndex: "id",
        key: "actions",
        title: this.props.i18n.t("Actions"),
        render: (val, item) => (
          <div className={classes.actions}>
            <div>
              <Tooltip placement="topLeft" title={this.props.i18n.t("Edit Site")}>
                <Icon type="edit" theme="filled" className={classes.actionIcon} onClick={() => { this.setState({ specimenSampleEdit: { id: item.id, kitId: item.kit, siteCode: item.site_code } }) }} />
              </Tooltip>
            </div>
            <div>
              <b className={classes.switchLabel}>{this.props.i18n.t("State")}</b>
              <br/>
              <Tooltip placement="topLeft" title={this.props.i18n.t("Activate / Deactivate")}>
                <Switch
                  className={classes.reactivateBtn}
                  checked={item.state === "active"}
                  onChange={this.onSwitchActivation(val, item.state)}
                />
              </Tooltip>
            </div>
          </div>
        ),
      }
    ];

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">{this.props.i18n.t("NamespaceSpecimenSample:Specimen sample")}</h3>

            <div className={classes.searchWrapper}>
              <label className={classes.searchWrapperSearch}>
                <b className={classes.searchWrapperLabel}>{this.props.i18n.t("SEARCH")}</b>
                <Search
                  placeholder=""
                  enterButton={this.props.i18n.t("Search")}
                  size="large"
                  onSearch={this.onNameSearch}
                  value={nameSearch}
                  onChange={this.onNameChange}
                  style={{ maxWidth: "500px" }}
                />
              </label>

              <span className={classes.clearButton} onClick={this.clearFilters}>
                {this.props.i18n.t("Clear")}
              </span>
            </div>

            {errorMessage && (
              <Alert
                type="error"
                message={errorMessage}
                className={classes.alert}
              />
            )}

            {responseMessage && (
              <Alert
                type="success"
                message={responseMessage}
                className={classes.alert}
              />
            )}

            <div className={classes.actionWrapper}>
              {specimenSampleCreatePermission && (
                <div>
                  <Button type="primary" onClick={this.addSpecimenSample}>
                    {this.props.i18n.t("Upload specimen samples")}
                  </Button>
                </div>
              )}
            </div>

            <div className={classes.wrapperFilters}>
              <div className={classes.searchWrapperFilterItemApprove}>
                <Checkbox
                  onChange={(e) =>
                    this.setState(
                      { isFilterApprove: e.target.checked },
                      this.getSpecimenSamples
                    )
                  }
                  checked={isFilterApprove}
                >
                  {this.props.i18n.t("Assigned to subject")}
                </Checkbox>
              </div>
            </div>


            <div style={{ position: 'relative' }}>
              <Table
                columns={columns}
                dataSource={specimenSamples}
                rowKey="id"
                locale={{ emptyText: isLoading ? ' ' : undefined }}
                onChange={this.handleTableChange}
                pagination={{
                  onShowSizeChange: (current, size) => {
                    this.setState({ pageSize: size });
                  },
                  onChange: () => {
                    this.setState(() => ({ checkedItems: [] }));
                  },
                  current: currentPage,
                  total,
                  pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "25", "50", "100"],
                }}
              />
              {isLoading && <div style={{position: 'absolute', top: 0, zIndex: 50, left: 0, width: '100%', height: '100%', background: 'rgba(255,255,255,0.9)', display: 'flex', justifyContent: 'center', alignItems: 'center'}}><Icon type="loading" style={{fontSize: '2rem', color: '#faa41a'}} /></div>}
            </div>
            <Modal
              visible={!!specimenSampleAdd}
              onCancel={this.onSpecimenSampleAddHide}
              footer={null}
            >
              {specimenSampleAdd && (
                <SpecimenSampleUploadForm
                  onSubmit={this.onSpecimenSampleAddSubmit}
                  onCancel={this.onSpecimenSampleAddHide}
                />
              )}
            </Modal>
            <Modal
              visible={!!specimenSampleEdit}
              onCancel={this.onSpecimenSampleEditHide}
              footer={null}
            >
              {specimenSampleEdit && (
                <SpecimenSampleEditForm
                  specimenSampleEdit={specimenSampleEdit}
                  sitesList={sitesList}
                  onSubmit={this.onSpecimenSampleEditSubmit}
                  onCancel={this.onSpecimenSampleEditHide}
                />
              )}
            </Modal>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  specimenSampleCreatePermission: getSpecimenSampleCreatePermission(state),
  specimenSampleUpdatePermission: getSpecimenSampleUpdatePermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(SpecimenSampleEditor))
);



// WEBPACK FOOTER //
// ./src/containers/SpecimenSampleEditor/SpecimenSampleEditor.js